module.exports = __webpack_public_path__ + "static/media/21-web-or-mls-DSC06635.c1303ed7.jpg";